import { Pouzivatel as PouzivatelGenerated, PouzivatelListApi } from 'iam-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { iamPrefixPath } from '../../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../../model/ClientResponse';
import Uuid from '../../../model/Uuid';
import { Pouzivatel } from '../../../model/iam/Pouzivatel';

const client = new PouzivatelListApi(apiConfiguration(iamPrefixPath));
const clientPublic = new PouzivatelListApi(apiConfiguration());

function map(pouzivatelList: PouzivatelGenerated[]): Pouzivatel[] {
  return pouzivatelList.map(pouzivatel => ({
    uuid: pouzivatel.userUUID,
    nazov: pouzivatel.fullName,
    nazovPozicie: pouzivatel.nazovPozicie,
  }));
}

export const fetchPouzivatelList = async (
  userUuid?: Uuid,
  orgUuid?: Uuid,
  // eslint-disable-next-line default-param-last
  execute = true,
  headers?: object,
): Promise<ClientResponse<Pouzivatel[]>> => {
  if (!execute) {
    return {
      data: [],
      responseCode: null,
    };
  }
  const {
    data,
    status,
  } = await client.getPouzivatelList(userUuid, orgUuid, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};

export const fetchPouzivatelByRoleList = async (
  roleId?: string,
  orgUuid?: Uuid,
  userFullNameContains?: string,
  headers?: object,
): Promise<ClientResponse<Pouzivatel[]>> => {
  const {
    data,
    status,
  } = await client.getPouzivatelWithRoleList(orgUuid, roleId, userFullNameContains, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};

export const fetchZodpovednyPredkladatelList = async (
  orgUuid?: string,
  userFullNameContains?: string,
  limit?: number,
  headers?: object,
): Promise<ClientResponse<Pouzivatel[]>> => {
  const {
    data,
    status,
  } = await clientPublic.getZodpovednyPredkladatelList(
    userFullNameContains,
    orgUuid,
    null,
    limit,
    headers,
  );
  return {
    data: data?.results ? map(data.results) : [],
    responseCode: status,
  };
};
